import { Stack, styled, Typography, type CSSObject } from '@mui/material';
import {
  Button,
  Section,
} from '@rumblefish/ui/src/components/Rumblefish23Theme';

import chequered from '../../../public/webp/fromPNG/chequered.webp';

export const StyledSection = styled(Section)(() => ({
  position: 'relative',
}));

export const StyledStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(0, 0, 9, 0),
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(8),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 0, 5, 0),
    gap: theme.spacing(4),
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0, 0, 9, 0),
    gap: theme.spacing(4),
  },
}));

export const StyledFrame = styled(Stack)(({ theme }) => ({
  width: '100%',

  background: theme.palette.invertedColors?.PLUS_8,
  borderRadius: theme.spacing(4),
  gap: theme.spacing(2),

  padding: `${theme.utils.fluidSize({
    minSize: 32,
    maxSize: 120,
    minBp: 960,
  })} ${theme.utils.fluidSize({ minSize: 32, maxSize: 280, minBp: 960 })}`,
  [theme.breakpoints.down('md')]: {
    backgroundImage: `none`,
    padding: '32px 32px',
  },
  [theme.breakpoints.down('sm')]: {
    backgroundImage: `none`,
    // padding: '24px 16px 32px 16px',
    padding: '24px 4px 32px 4px',
  },
  [theme.breakpoints.up('xl')]: {
    padding: '60px 200px',
  },

  backgroundImage: ` url(${chequered})`,
}));

export const StyledHeadlineWrapper = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    padding: '0px 32px',
  },
}));

export const StyledHeadline = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}));

export const StyledHeadlineDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
  lineHeight: '28px !important',
  marginBottom: '1rem',
}));

export const StyledButtonWrapper = styled(Stack)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  marginTop: theme.spacing(4),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  boxShadow: `0px 0px 6px 4px ${theme.palette.purpleColors?.PLUS_2} !important`,

  '.MuiStack-root': {
    backgroundColor: 'transparent !important',
    border: '1px solid white',
    boxShadow: `0px 0px 6px 4px ${theme.palette.purpleColors?.PLUS_2} inset !important`,
  },
}));
